import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { BookingDuration } from 'src/app/simulator-booking/models/booking-duration';
import { PriceBand } from 'src/app/simulator-booking/models/price-band';
import { Simulator } from 'src/app/simulator-booking/models/simulators';
import { BookingDurationService } from 'src/app/simulator-booking/services/booking-duration.service';
import { PriceBandService } from 'src/app/simulator-booking/services/price-band.service';
import { PriceService } from 'src/app/simulator-booking/services/price.service';
import { SimulatorService } from 'src/app/simulator-booking/services/simulator.service';

@Component({
    selector: 'price-create-modal',
    templateUrl: './price-create-modal.component.html',
    styleUrl: './price-create-modal.component.scss',
    standalone: false
})
export class PriceCreateModalComponent extends BaseModalComponent{
  public form = new FormGroup({
    simulatorId: new FormControl('',{
      validators: Validators.required
    }),
    priceBandId: new FormControl('',{
      validators: Validators.required
    }),
    amount: new FormControl(0 ,{
      validators: Validators.required
    }),
    durationMinutes: new FormControl(30 ,{
      validators: Validators.required
    }),
    organizationId: new FormControl('',{
      validators: Validators.required
    }),
    createdBy: new FormControl(),
  });

  public simulators: Simulator[] = [];
  public priceBands: PriceBand[] = []; 
  public availableDurations: BookingDuration[] = [];

  constructor(private sessionService: SessionService,
    private priceService: PriceService,
    private simulatorService: SimulatorService,
    private priceBandService: PriceBandService,
    private bookingDurationService: BookingDurationService,
    public dialogRef: MatDialogRef<PriceCreateModalComponent>) {
    super();
    this.form.get('organizationId').setValue(this.sessionService.getUser().organizationId);
    this.form.get('createdBy').setValue(this.sessionService.getUserId());
    this.isLoading = true;
    this.getSimulators();
  }

  getSimulators(){
    this.simulatorService.getAllByOrganization({organizationId: this.sessionService.getUser().organizationId}).subscribe({
      next: (result) => this.simulators = result.results,
      error: (error) => {
        console.error(error);
        this.isLoading = false;
      },
      complete: () => this.getPriceBands()
    });
  }

  getPriceBands(){
    this.priceBandService.getAllByOrganization({organizationId: this.sessionService.getUser().organizationId}).subscribe({
      next: (result) => this.priceBands = result.results,
      error: (error) => {
        console.error(error);
        this.isLoading = false;
      },
      complete: () => this.getBookingDurations()
    });
  }


  getBookingDurations(){
    this.bookingDurationService.getAllByOrganization({organizationId: this.sessionService.getUser().organizationId}).subscribe({
      next: (result) => this.availableDurations = result,
      error: (error) => {
        console.error(error);
        this.isLoading = false;
      },
      complete: () => this.isLoading = false
    });
  }

  submit({value, valid}){
    if(valid){
      this.isLoading = true;
      this.priceService.create(value).subscribe({
        next: (result) => {
          if(result !== null || result !== undefined){
            this.dialogRef.close("save");
          }
        },
        error: (error) => {
          this.isLoading = false;
          console.error(error);
          this.setErrorV2(error, this.form);
        },
        complete: () => this.isLoading = false
      });
    }
  }
}
